import React from "react";
import {
    Dialog,
    DialogContent,
    IconButton,
    Box,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ReactPlayer from "react-player";

export default function VideoModal({ open, onClose, video }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogContent
                sx={{
                    p: { xs: 1.5, md: 2 },
                    background: "var(--preto)",
                    position: "relative",
                }}
            >
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 10,
                        top: 10,
                        zIndex: 2,
                        bgcolor: "rgba(255,255,255,0.08)",
                        border: "1px solid rgba(255,255,255,0.12)",
                        "&:hover": { bgcolor: "rgba(255,255,255,0.12)" },
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <Box sx={{ pt: 1 }}>
                    <Typography sx={{ fontWeight: 900, mb: 1.5 }}>
                        {video?.title || "Vídeo"}
                    </Typography>

                    <Box
                        sx={{
                            borderRadius: 3,
                            overflow: "hidden",
                            border: "1px solid rgba(255,255,255,0.10)",
                            bgcolor: "rgba(255,255,255,0.04)",
                            aspectRatio: "16 / 9",
                        }}
                    >
                        <ReactPlayer
                            url={video?.url}
                            width="100%"
                            height="100%"
                            playing
                            controls
                        />
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
}